import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  ClientQuestionnaireResultBase,
} from '../../../../../../../modules/src/lib/questionnaires/components/base-client-questionnaire/form/base-result/client-questionnaire-result.base';
import { DateUtils } from '../../../../../../../modules/src/lib/core/utils/date.utils';
import {
  ClientQuestionnaireStore,
} from '../../../../../../../modules/src/lib/questionnaires/stores/client-questionnaire.store';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AlertMessageStore } from '../../../../../../../modules/src/lib/core/stores/alert-message.store';
import { environment } from '../../../../../environments/environment';
import { CivilStatusEnum } from '../../../../../../../../../common/src/enums/civil-status.enum';
import {
  ClientQuestionnaireStatusEnum,
} from '../../../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-status.enum';
import {
  SalaryDividendTaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/salary-dividend/salary-dividend-tax-questionnaire.options';
import {
  SalaryDividendTaxQuestionnaireResultFactory,
} from '../../../../../../../modules/src/lib/questionnaires/components/salary-dividend-tax-questionnaire/result/salary-dividend-tax-questionnaire-result.factory';
import {
  ClientQuestionnairesApiController,
} from '../../../../../../../modules/src/lib/questionnaires/api-controllers/client-questionnaires.api-controller';
import { ViewStateEnum } from '../../../../enums/view-state.enum';

@Component({
  selector: 'app-salary-dividend-view-client-questionnaire',
  templateUrl: './salary-dividend-view-client-questionnaire.component.html',
  styleUrls: ['./salary-dividend-view-client-questionnaire.component.scss'],
  standalone: false,
})
export class SalaryDividendViewClientQuestionnaireComponent extends ClientQuestionnaireResultBase<SalaryDividendTaxQuestionnaireOptions> implements OnInit, OnDestroy {

  hasCopied = false;
  isMainSpouseTab: boolean = true;
  civilStatusEnum = CivilStatusEnum;
  clientQuestionnaireStatusEnum = ClientQuestionnaireStatusEnum;

  convertingClientQuestionnaireStatus: ViewStateEnum = ViewStateEnum.Ready;
  protected readonly ViewStateEnum = ViewStateEnum;

  constructor(public readonly formFactory: SalaryDividendTaxQuestionnaireResultFactory,
              clientQuestionnaireStore: ClientQuestionnaireStore,
              private readonly apiController: ClientQuestionnairesApiController,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              dateUtils: DateUtils,
              // calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    super(formFactory, clientQuestionnaireStore, translateService, activatedRoute, router, optionsMapper, dateUtils, alertMessageStore);
    this.optionsType = SalaryDividendTaxQuestionnaireOptions;
  }

  getLink() {
    if (this.clientQuestionnaireResponse === undefined) {
      return 'Chargement...';
    }

    return environment.clientPortal.host + '/questionnaires/' + this.clientQuestionnaireResponse.keyname + '/' + this.clientQuestionnaireResponse.id;
  }

  copyToClipboard() {
    this.hasCopied = true;
    return navigator.clipboard.writeText(this.getLink());
  }

  mailtoLink() {
    return 'mailto:' + this.getClientEmail() + '?subject=Vous avez un questionnaire pour l\'analyse Salaires-Dividendes à remplir&body=Bonjour ' + this.getClientName() + ', %0D%0A%0D%0AUn questionnaire de collecte d\'information pour le calcul salaires-dividendes est disponible. Afin de faciliter la collecte de vos données, voici le lien vers un questionnaire électronique à remplir: ' + this.getLink() + ' %0D%0A%0D%0AVous devez vous connecter avec le email suivant:\'' + this.getClientEmail() + '\'. %0D%0A%0D%0ALaissez-moi savoir si vous avez des questions!';
  }

  async convertToCalculation() {
    this.convertingClientQuestionnaireStatus = ViewStateEnum.Loading;

    const questionnaire = this.clientQuestionnaireResponse;

    const calculation = await this.apiController.convertToCalculation(questionnaire.id);

    this.convertingClientQuestionnaireStatus = ViewStateEnum.Ready;

    await this.router.navigateByUrl(`/calculations/${calculation.calculationKeyname}/${calculation.calculationId}`);
  }
}
